import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from 'src/app/layout/services/dialog.service';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import Swal from 'sweetalert2';
import { DocumentCategoryService as ComponentService } from './document-category.service';
import { AddDocumentCategoryComponent as AddComponent } from './add-document-category/add-document-category.component';
import { EditDocumentCategoryComponent as EditComponent } from './edit-document-category/edit-document-category.component';
import { helper } from 'src/environments/helper';
import { PermissionsService } from '../../../services/permissions.service';

@Component({
  selector: 'app-document-category',
  templateUrl: './document-category.component.html',
  styleUrls: ['./document-category.component.scss'],
})
export class DocumentCategoryComponent
  implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;
  helper = helper;

  isLoading = false;
  showCard = false;
  activeValue: string = '-1';
  publicValue: string = '-1';

  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();
  dtInstance!: DataTables.Api;

  dtLink = this.componentService.getListDTUrl;

  parameters: { key: string; value: string }[] = [
    { key: '--Alegeți--', value: '-1' },
    { key: 'Da', value: '1' },
    { key: 'Nu', value: '0' },
  ];

  resetForm() {
    this.activeValue = '-1';
    this.publicValue = '-1';

    this.rerenderDT();
    this.showCard = true;
  }

  applyFilters(): void {
    this.rerenderDT(true);
  }

  toggleCard() {
    this.showCard = !this.showCard;
  }
  constructor(
    private dialogService: DialogService,
    private http: HttpClient,
    private dialog: MatDialog,
    private componentService: ComponentService,
    public permissionsService: PermissionsService
  ) { }

  ngOnInit(): void {
    this.renderDT();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next('');
  }

  renderDT() {
    this.isLoading = true;
    this.dtOptions = {
      responsive: true,
      serverSide: true,
      searching: false,
      pageLength: 25,
      ajax: (dataTablesParameters: any, callback: any) => {
        this.isLoading = true;
        dataTablesParameters.active = this.activeValue;
        dataTablesParameters.public = this.publicValue;

        this.http
          .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
          .subscribe((resp: any) => {
            this.isLoading = false;
            callback({
              recordsTotal: resp.data.recordsTotal,
              recordsFiltered: resp.data.recordsFiltered,
              data: resp.data.data,
            });
          });
      },
      language: environment.config.romanianLanguageDataTable,
      columns: [
        {
          title: 'ID',
          data: 'id',
        },
        {
          title: 'Slug',
          data: 'slug',
        },
        {
          title: 'Denumire',
          data: 'name',
          width: '400px',
        },
        {
          title: 'Acțiuni',
          data: null,
          orderable: false,
          className:'all',
          render: () => {
            return `
              <button class="action-btn edit">
                <img class="btn-img" src="../../../../assets/icons/edit.svg" alt="edit"/>
              </button>
              <button class="action-btn delete">
                <img class="btn-img" src="../../../../assets/icons/delete.svg" alt="delete"/>
              </button>
            `;
          },
        },
      ],
      rowCallback: (row: Node, data: any[] | any) => {
        const lastTd = (row as HTMLElement).querySelector('td:last-child');
        const editIcon = lastTd ?.querySelector('.edit') as HTMLElement;
        const deleteIcon = lastTd ?.querySelector('.delete') as HTMLElement;

        if (editIcon) {
          if (!this.permissionsService.hasPermission('urbanism-module.settings.categorii-documente.update')) {
            editIcon.style.display = 'none';
          }
          editIcon.addEventListener('click', () => {
            this.openEditDialog(data);
          });
        }

        if (deleteIcon) {
          if (!this.permissionsService.hasPermission('urbanism-module.settings.categorii-documente.delete')) {
            deleteIcon.style.display = 'none';
          }
          deleteIcon.addEventListener('click', () => {
            const { id } = data;
            this.delete(id);
          });
        }

        return row;
      },
    };
  }

  rerenderDT(paginate: boolean = false): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.draw(paginate);
    });
    this.showCard = false;
  }

  openAddDialog() {
    const dialogRef = this.dialog.open(AddComponent, {
      ...this.dialogService.getDialogConfig(),
    });
    dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
      if (success) {
        this.isLoading = true;
        this.rerenderDT();
        Swal.fire({
          title: helper.dialogConfig.headers.success,
          text: 'Inregistrare adaugată cu succes.',
          icon: 'success',
          confirmButtonText: helper.dialogConfig.buttonLabels.close,
          allowOutsideClick: false,
        });
      }
    });
  }

  openEditDialog(data: any) {
    const dialogRef = this.dialog.open(EditComponent, {
      ...this.dialogService.getDialogConfig(),
      data,
    });

    dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
      if (success) {
        this.isLoading = true;
        this.rerenderDT();
        Swal.fire({
          title: helper.dialogConfig.headers.success,
          text: 'Inregistrare actualizată cu succes.',
          icon: 'success',
          confirmButtonText: helper.dialogConfig.buttonLabels.close,
          allowOutsideClick: false,
        });
      }
    });
  }

  delete(id: number) {
    Swal.fire({
      title: helper.swalTextConfig.commonTitles.areYouSure,
      text: helper.swalTextConfig.generalMessages.delete,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      confirmButtonText: helper.swalTextConfig.buttonLabels.confirm,
      cancelButtonText: helper.swalTextConfig.buttonLabels.close,
      showLoaderOnConfirm: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.componentService.delete(id).subscribe(() => {
          this.rerenderDT();
          Swal.fire({
            title: helper.swalTextConfig.headers.deleted,
            text: 'Inregistrare ștersă cu succes.',
            icon: 'success',
            confirmButtonText: helper.swalTextConfig.buttonLabels.ok,
          });
        });
      }
    });
  }

  clearCache() {
    Swal.fire({
      title: helper.swalTextConfig.commonTitles.areYouSure,
      text: helper.swalTextConfig.generalMessages.cleanCache,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      confirmButtonText: helper.swalTextConfig.buttonLabels.confirm,
      cancelButtonText: helper.swalTextConfig.buttonLabels.close,
      showLoaderOnConfirm: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.componentService.clearCache().subscribe(() => {
          this.rerenderDT();
          Swal.fire({
            title: helper.swalTextConfig.headers.deleted,
            text: helper.swalTextConfig.generalMessages.cleanCacheSuccess,
            icon: 'success',
            confirmButtonText: helper.swalTextConfig.buttonLabels.ok,
          });
        });
      }
    });
  }
}
